@use 'themes/westfield' as *;
// Paragraph styles
// ================

@use 'tools/typography.module' as *;

.large {
  @extend .paragraphLarge;
}

.medium {
  @extend .paragraphMedium;
}

.small {
  @extend .paragraphSmall;
}
